import { boot } from 'quasar/wrappers'
import * as Sentry from '@sentry/vue'
import { socketBuffer } from '../services/sentry/SocketBreadcrumbBuffer'

const DSN = process.env.VUE_APP_SENTRY_DSN
const ENVIRONMENT = process.env.VUE_APP_SENTRY_ENVIRONMENT || 'development'
const RELEASE = process.env.VUE_APP_SENTRY_RELEASE || undefined
const ENABLED = String(process.env.VUE_APP_SENTRY_ENABLED || 'false') === 'true'

const PUBLIC_PATHS = new Set(['/login', '/login/signin', '/login/forgot'])

const isAuthenticated = (store: any): boolean => {
  const main = store?.state?.main
  return Boolean(main?.user?._id && main?.account?._id)
}

export default boot(({ app, router, store }) => {
  if (!ENABLED || !DSN) {
    if (!DSN) {
      console.info('[Sentry] disabled — VUE_APP_SENTRY_DSN not set')
    } else {
      console.info('[Sentry] disabled by VUE_APP_SENTRY_ENABLED')
    }
    return
  }

  Sentry.init({
    app,
    dsn: DSN,
    environment: ENVIRONMENT,
    release: RELEASE,
    attachProps: true,
    attachErrorHandler: true,
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'Non-Error promise rejection captured',
    ],
    integrations: [
      Sentry.vueIntegration({ tracingOptions: { trackComponents: true } }),
      Sentry.browserTracingIntegration({ router }),
      Sentry.captureConsoleIntegration({ levels: ['error'] }),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
      ///TODO: 
      // Sentry.feedbackIntegration({
      //   colorScheme: 'system',
      //   autoInject: false,
      //   showBranding: false,
      //   triggerLabel: 'Reportar problema',
      //   formTitle: 'Reportar problema',
      //   submitButtonLabel: 'Enviar',
      //   cancelButtonLabel: 'Cancelar',
      //   nameLabel: 'Nome',
      //   namePlaceholder: 'Seu nome',
      //   emailLabel: 'E-mail',
      //   emailPlaceholder: 'seu@email.com',
      //   messageLabel: 'Descrição',
      //   messagePlaceholder: 'O que aconteceu? Inclua os passos para reproduzir.',
      //   successMessageText: 'Obrigado pelo feedback!',
      // }),
    ],
    beforeSend(event) {
      try {
        const events = socketBuffer.snapshot()
        event.contexts = {
          ...(event.contexts || {}),
          socket_buffer: {
            count: events.length,
            window_seconds: 60,
            events,
          },
        }
      } catch (err) {
        console.error('[Sentry] failed to attach socket buffer:', err)
      }
      return event
    },
    beforeBreadcrumb(breadcrumb) {
      return breadcrumb
    },
  })

  console.info(`[Sentry] initialized (env=${ENVIRONMENT})`)

  let feedbackWidget: { removeFromDom: () => void } | null = null

  const syncFeedbackWidget = (path: string) => {
    const shouldShow = isAuthenticated(store) && !PUBLIC_PATHS.has(path)
    const feedback = Sentry.getFeedback()
    if (!feedback) return

    if (shouldShow && !feedbackWidget) {
      try {
        feedbackWidget = feedback.createWidget()
      } catch (err) {
        console.error('[Sentry] failed to create feedback widget:', err)
      }
    } else if (!shouldShow && feedbackWidget) {
      try {
        feedbackWidget.removeFromDom()
      } catch (err) {
        console.error('[Sentry] failed to remove feedback widget:', err)
      }
      feedbackWidget = null
    }
  }

  router.afterEach((to) => {
    syncFeedbackWidget(to.path)
  })
})
